import React from 'react'
import { BigButton } from '@gravitate-js/excalibrr'
import { orderTypes, paneModes } from '@constants/orderWizard'
import backhaulImg from '@assets/CustomIcons/backhaul.svg'
import gasStationImg from '@assets/CustomIcons/gas_station.svg'
import { PaneHeader } from './PaneComponents/Layout/PaneHeader'

export const TypeSelect = ({ order, setOrder, setPaneMode }) => {
  const changeOrderType = (orderType) => {
    const orderCopy = { ...order, type: orderType }
    setOrder(orderCopy)
    setPaneMode(paneModes.PRODUCTSELECT)
  }

  const BackHaulButton = (props) => (
    <BigButton label='Backhaul' onClick={() => changeOrderType(orderTypes.BACKHAUL)} image={backhaulImg} {...props} />
  )

  const StoreDeliveryButton = (props) => (
    <BigButton
      onClick={() => changeOrderType(orderTypes.STOREDELIVERY)}
      label='Site Delivery'
      image={gasStationImg}
      {...props}
    />
  )

  return (
    <>
      <PaneHeader title='Choose Order Type' />
      <div className='pane-content type-pane'>
        <StoreDeliveryButton />
        <BackHaulButton />
      </div>
    </>
  )
}
